import { useTranslation } from "react-i18next";

export function CalendarLegend() {
  const { t } = useTranslation();

  return (
    <div className="bg-white border-y sm:border border-border p-4 sm:rounded-xl mt-4 -mx-4 sm:mx-0 text-sm grid grid-cols-1 gap-1.5">
      <div className="flex items-center gap-2">
        <div className="w-4 h-1 rounded-full bg-green" />
        <span className="font-medium">{t("calendar.legendAvailable")}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-1 rounded-full bg-orange" />
        <span className="font-medium">{t("calendar.legendLimited")}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-1 rounded-full bg-red" />
        <span className="font-medium">{t("calendar.legendUnavailable")}</span>
      </div>
    </div>
  );
}
